import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';

//Components
import TextField from '../../../../../components/TextField';
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';

//Constants
import { actionsTable } from '../../../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../../../context/auth';

//Helpers
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../../helpers/mascaras';
import { showMessage, showQuestion } from '../../../../../helpers/message';
import formulario_api from '../../../../../api/formulario_api';

function initialStateQuestao(formulario_id) {
    return {
        questao: "",
        sequencia: "",
        tipoValor: "",
        obrigatorio: "false",
        possuiDependencia: "false",
        deletado: "false",
        formularioQuestaoDependentes: [],
        formularioQuestoesOpcos: [],
        formulario_id: formulario_id
    }
}
function initialStateQuestaoDependente(formularioQuestao_Id) {
    return {
        formularioQuestao_Id: formularioQuestao_Id ? formularioQuestao_Id : null,
        questaoPai_Id: "",
        questaoPai_Valor: "",
    }
}
export default function Questoes({ formulario, loadFormulario, editavel }) {

    const { setLoading } = useAuth();

    //Estado de controle da visibilidade do formulario de adicionar questões
    const [visibleForm, setVisibleForm] = useState(false);

    const toggleForm = () => {
        setVisibleForm(!visibleForm);
        if (visibleForm) {
            setQuestao(initialStateQuestao(formulario.id));
            setQuestaoDependente(initialStateQuestaoDependente);
            setErrorsQuestaoDependente({});
            setErrors({});
        }
    }

    //Estado de controle dos erros
    const [errors, setErrors] = useState({});

    //Estado de controle dos erros na questão dependente
    const [errorsQuestaoDependente, setErrorsQuestaoDependente] = useState({});

    //Estado de controle dos dados da questão
    const [questao, setQuestao] = useState(initialStateQuestao(formulario.id));

    //Estado de controle dos dados da questão dependente
    const [questaoDependente, setQuestaoDependente] = useState(initialStateQuestaoDependente);

    //Função de onchange da questão pai
    const onChangeQuestaoPai = (value, e) => {
        setQuestaoDependente({
            ...questaoDependente,
            [e.name]: value ? value.value : null,
        });
    }
    //Função de onChange dos campos da questão dependente
    const onChangeQuestaoDependente = (e) => {
        const { name, value } = e.target;

        setQuestaoDependente({
            ...questaoDependente,
            [name]: value
        })
    }

    const optionsTipoValor = [
        { value: "", label: "Selecione uma opção" },
        { value: "Texto", label: "Texto" },
        { value: "Número", label: "Número" },
        { value: "Data", label: "Data" },
        { value: "Lista", label: "Lista" },
        { value: "Lista Múltipla Seleção", label: "Lista Múltipla Seleção" },
    ]

    //Campos obrigatorios no cadastro de uma questão
    const [campos] = useState([
        objCampo({ name: "questao", required: true }),
        objCampo({ name: "sequencia", required: true }),
        objCampo({ name: "tipoValor", required: true }),
        objCampo({ name: "obrigatorio", required: true }),
        objCampo({ name: "possuiDependencia", required: true })
    ]);

    const camposQuestaoDependente = [
        objCampo({ name: "questaoPai_Id", required: true }),
        objCampo({ name: "questaoPai_Valor", required: true }),
    ]

    const editar = (questaoEdit) => {
        if (questaoEdit.possuiDependencia == "true") {
            const _questaoDependente = { ...questaoEdit.formularioQuestaoDependentes[0] };
            _questaoDependente.questaoPai_Id = _questaoDependente.questaoPai_Id.toString();
            setQuestaoDependente(_questaoDependente);
        } else {
            setQuestaoDependente(initialStateQuestaoDependente(questaoEdit.id));
        }
        setQuestao(questaoEdit);
        setVisibleForm(true);
    }

    const remover = (questaoRemove) => {
        showQuestion("Tem certeza?", "tem certeza de que deseja deletar essa questão?\n Esta ação é irreversível", "info",
            (confirmation) => {
                if (confirmation) {
                    setLoading(true);
                    formulario_api.deleteFormularioQuestao(questaoRemove.id).then(response => {
                        showMessage("Sucesso", "Questão removida com sucesso", "success", () => loadFormulario())
                    }).catch(ex => showMessage("Erro", ex.message, "error", null))
                        .finally(f => setLoading(false));
                }
            })
    }
    //Ações que a tabela terá
    const actions = [
        ...editavel ?
            [actionsTable.editar(editar),
            actionsTable.remover(remover)]
            : [actionsTable.visualizar(editar)]
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "questao", align: "left" },
        { value: "Tipo", objectValue: "tipoValor", align: "left" },
        { value: "Sequência", objectValue: "sequencia", align: "left" },
    ]

    //Função de onChange dos campos das questões
    const onChange = (e) => {
        const { name, value } = e.target;
        const _questao = {
            ...questao,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_questao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setQuestao(_questao);
    }

    //Função de onChange para o campo de tipo de valor
    const onChangeTipo = (e) => {
        const { name, value } = e.target;
        const _questao = {
            ...questao,
            [name]: value,
            formularioQuestoesOpcos: (value === "Lista" || value === "Lista Múltipla Seleção") ? questao.formularioQuestoesOpcos : []
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_questao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setQuestao(_questao);
    }
    //OnChange para o campo de opções de resposta
    const onChangeOpcoes = (inputValue) => {
        setQuestao({
            ...questao,
            formularioQuestoesOpcos: typeof inputValue === "object" ? [...questao.formularioQuestoesOpcos.filter(opcao => inputValue.some(value => value.value == opcao.valor))] : [...questao.formularioQuestoesOpcos, { formularioQuestao_Id: questao.id ? questao.id : null, valor: inputValue }]
        });
    }

    //Função de salvamento do step
    const salvarQuestao = () => {
        const _errors = validarCampos(questao, campos);

        if ((questao.tipoValor === "Lista" || questao.tipoValor === "Lista Múltipla Seleção") && questao.formularioQuestoesOpcos.length == 0) {
            _errors[0]["formularioQuestoesOpcos"] = { message: "" };
            _errors[1].push(objCampo({ name: "formularioQuestoesOpcos", required: true }))
        }
        setErrors(_errors[0]);

        const _errorsQuestaoDependente = validarCampos(questaoDependente, camposQuestaoDependente);
        setErrorsQuestaoDependente(_errorsQuestaoDependente[0]);


        if (_errors[1].length > 0
            || (questao.possuiDependencia == "true" && _errorsQuestaoDependente[1].length > 0)
        )
            return;

        const _questaoDependente = { ...questaoDependente };
        if (_questaoDependente.formularioQuestao_Id == null)
            delete _questaoDependente.formularioQuestao_Id;

        const _questao = {
            ...questao,
            formularioQuestaoDependentes: questao.possuiDependencia == "true" ? [{ ..._questaoDependente }] : []
        };
        _questao.obrigatorio = _questao.obrigatorio === "true";
        _questao.possuiDependencia = _questao.possuiDependencia === "true";
        _questao.deletado = _questao.deletado === "true";

        if (_questao.id) {
            setLoading(true)
            formulario_api.putFormularioQuestao(_questao).then(response => {
                showMessage("Sucesso", "Questão atualizada com sucesso!", "success", () => {
                    toggleForm();
                    loadFormulario();
                });
            }).catch(ex => showMessage("Erro", ex.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            _questao.formularioQuestoesOpcos = _questao.formularioQuestoesOpcos.map(value => {
                delete value.formularioQuestao_Id;
                return value;
            });
            _questao.formularioQuestaoDependentes = _questao.formularioQuestaoDependentes.map(value => {
                delete value.formularioQuestao_Id;
                return value;
            })
            setLoading(true)
            formulario_api.postFormularioQuestao(_questao).then(response => {
                showMessage("Sucesso", "Questão criada com sucesso!", "success", () => {
                    toggleForm();
                    loadFormulario();
                });
            }).catch(ex => showMessage("Erro", ex.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    return (
        <>
            <h5 className='mb-3 d-flex align-items-center justify-content-between'>Questões
                {editavel &&
                    <Button color='success' onClick={toggleForm}>+ Adicionar</Button>
                }
            </h5>
            <div className={`formContainer ${!visibleForm ? "close" : ""}`}>
                <Row className='mx-4'>
                    <Col md="12" lg="4">
                        <TextField
                            mask={mascaras.numeroMask}
                            name={"sequencia"}
                            label={"Sequência"}
                            onChange={onChange}
                            value={questao.sequencia}
                            invalid={!!errors.sequencia}
                            disabled={!editavel} />
                    </Col>
                    <Col md="12" lg="8">
                        <TextField
                            name={"questao"}
                            label={"Identificação"}
                            onChange={onChange}
                            value={questao.questao}
                            invalid={!!errors.questao}
                            disabled={!editavel} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            name={"tipoValor"}
                            label={"Tipo do valor "}
                            type={"select"}
                            options={optionsTipoValor}
                            onChange={onChangeTipo}
                            value={questao.tipoValor}
                            invalid={!!errors.tipoValor}
                            disabled={!editavel} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"radio"}
                            label="* Obrigátorio"
                            name={"obrigatorio"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={questao.obrigatorio}
                            invalid={!!errors.obrigatorio}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"radio"}
                            label="* Possui dependência"
                            name={"possuiDependencia"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={questao.possuiDependencia}
                            invalid={!!errors.possuiDependencia}
                            disabled={!editavel}
                        />
                    </Col>
                    {questao.possuiDependencia == "true" &&
                        <>
                            <Col md="12" lg="8" className='mt-2'>
                                <TextField
                                    label={"* Questão pai"}
                                    type="select"
                                    searchable
                                    options={formulario.formularioQuestos.map(value => {
                                        return { value: value.id, label: value.questao }
                                    })}
                                    name={"questaoPai_Id"}
                                    onChange={onChangeQuestaoPai}
                                    value={formulario.formularioQuestos.map(value => {
                                        return { value: value.id, label: value.questao }
                                    }).filter(value => value.value == questaoDependente.questaoPai_Id)}
                                    invalid={!!errorsQuestaoDependente.questaoPai_Id}
                                    disabled={!editavel}
                                />
                            </Col>
                            <Col md="12" lg="4" className='mt-2'>
                                <TextField
                                    label={"* Valor"}
                                    name={"questaoPai_Valor"}
                                    onChange={onChangeQuestaoDependente}
                                    value={questaoDependente.questaoPai_Valor}
                                    invalid={!!errorsQuestaoDependente.questaoPai_Valor}
                                    disabled={!editavel}
                                />
                            </Col>
                        </>}
                    {
                        (questao.tipoValor === "Lista" || questao.tipoValor === "Lista Múltipla Seleção") &&
                        <Col md="12" lg="12" className='mt-2'>
                            <TextField
                                invalid={!!errors.formularioQuestoesOpcos}
                                label={"* Opções de resposta"}
                                type="select"
                                creatable
                                name={"formularioQuestoesOpcos"}
                                onChange={onChangeOpcoes}
                                value={questao.formularioQuestoesOpcos.map(value => {
                                    return { value: value.valor, label: value.valor };
                                })}
                                disabled={!editavel}
                            />
                        </Col>
                    }
                    <Col md="12" lg="12" className='d-flex align-items-center justify-content-center'>
                        <Button className='px-4 mb-5 me-4' color={"secondary"} onClick={() => {
                            toggleForm()
                        }}>Cancelar</Button>
                        {editavel &&
                            <Button className='px-4 mb-5' color={questao.tableData ? 'warning text-white' : 'success'} onClick={salvarQuestao}>{questao.tableData ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Adicionar"}</Button>
                        }
                    </Col>
                </Row>
            </div>
            <TabelaListagem actions={actions} title={"Lista de questões"} options={{ print: false, search: true, pagination: true }} headers={headers} items={formulario.formularioQuestos} />
        </>
    )
}